import { getAuthData } from "../auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import { loadStartupCards } from "./loadCards.jsx";
export const I3 = 8e3;
export function useStartup() {
  const [u, o] = React.useState({
    ready: !1,
    phase: "cards",
    data: null
  });
  return React.useEffect(() => {
    let m = !0;
    const r = window.setTimeout(() => {
        m && o(j => ({
          ...j,
          ready: !0
        }));
      }, I3),
      g = getAuthData();
    return g ? (loadStartupCards(g, j => {
      m && o(B => ({
        ...B,
        phase: j
      }));
    }).then(j => {
      m && o({
        ready: !0,
        phase: "banners",
        data: j
      });
    }).catch(() => {
      m && o(j => ({
        ...j,
        ready: !0
      }));
    }).finally(() => window.clearTimeout(r)), () => {
      m = !1, window.clearTimeout(r);
    }) : (window.clearTimeout(r), o(j => ({
      ...j,
      ready: !0
    })), () => {
      m = !1;
    });
  }, []), u;
}
